import { defineMessages } from 'react-intl';

const messages = defineMessages({
  logoTitle: {
    id: 'components.logo.logoTitle',
    defaultMessage: 'My Fit World',
  },
});

export default messages;
